import React, { useRef, useState } from 'react';
import './style.scss';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import { Accessibility } from '../../../utils/Accessibility/Accessibility';
import { useEffect } from 'react';

interface GroupPointsModuleProps {
  groupId: number;
  viewLeaderboard: Function;
}

interface GroupOrdinalObject {
  points?: number;
  place?: string;
}

const GroupPointsModule: React.FC<GroupPointsModuleProps> = ({ ...props }) => {
  const [ordinal, setOrdinal] = useState<GroupOrdinalObject>({ points: undefined, place: undefined });

  const onLeaderboard = function () {
    let params = { viewTeamStandingsOnStart: true };
    Accessibility.focusedElement = document.activeElement as HTMLElement;
    props.viewLeaderboard(params);
  };

  const updateGroupOrdinal = () => {
    const aUrl = 'crowdhub_api_v2/api_group_get_points.php';

    const aVars = {
      group_id: props.groupId,
    };

    App.INSTANCE.mApi.Request(CrowdHub_App.CONFIG.BASE_URL + aUrl, aVars, aData => {
      if (aData.success == 'true') {
        setOrdinal({ points: aData['points'], place: `${GlobalHelperFunctions.formatPlace(aData['place'])} Place` });
      }
      aData => {
        // group ordinal won't display
        console.log(aData);
      };
    });
  };

  useEffect(() => {
    updateGroupOrdinal();
  }, []);

  return (
    <div className="hover-grow">
      <div className="group_points_container" onClick={onLeaderboard}>
        <div className="group_points_main_icon_container">
          <i className={FontAwesomeConfigurations.ICON_TROPHY_STAR}></i>
        </div>
        <div className="group_points_label">{CrowdHub_App.LANG.GROUP_LEADERBOARD_TITLE}</div>
        <div className="group_points_text_container">
          <div className="group_points_icon_container brand_color_color">
            <i className={FontAwesomeConfigurations.ICON_POINTSBOLT_SOLID}></i>
          </div>
          <div className="points brand_color_color">{ordinal.points}</div>
          <div className="divider">|</div>
          <div className="place">{ordinal.place}</div>
        </div>
      </div>
    </div>
  );
};

export default GroupPointsModule;
